import React from 'react'
import Layout from '../../common/Layout'
import AdviserLogin from '../../features/AdviserLogin'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/adviser/login',
  async action () {
    return {
      title: 'Adviser',
      component: <Layout><AdviserLogin /></Layout>
    }
  }
}
